import React from "react";
import './Testimonial.css'
import {Swiper, SwiperSlide} from "swiper/react"
import ProfilePic1 from '../../img/ProfilePic1.png';
import ProfilePic2 from '../../img/ProfilePic2.png';
import ProfilePic3 from '../../img/ProfilePic3.png';
import ProfilePic4 from '../../img/ProfilePic4.png';
import { Pagination } from "swiper";
import 'swiper/css/pagination';
import 'swiper/css'
import { themeContext } from "../../Context";
import { useContext } from "react";

const Testimonial = () =>{

    const theme = useContext(themeContext);
    const darkMode = theme.state.darkMode;

   const clients = [

    {
        img: ProfilePic1,
        review: 
        "Lorem ipsum dolor, sit amet consectetur adipiscing elit. Exofficiis molestiae quod tempora laudantium, cumque error a nisiplaceat quae exercitationem, maiores reicients! Exaque dicta minima, iure maiores dolorum sed.",
    },

    {
        img: ProfilePic2,
        review: 
        "Lorem ipsum dolor, sit amet consectetur adipiscing elit. Exofficiis molestiae quod tempora laudantium, cumque error a nisiplaceat quae exercitationem, maiores reicients! Exaque dicta minima, iure maiores dolorum sed.",
    },

    {
        img: ProfilePic3,
        review: 
        "Lorem ipsum dolor, sit amet consectetur adipiscing elit. Exofficiis molestiae quod tempora laudantium, cumque error a nisiplaceat quae exercitationem, maiores reicients! Exaque dicta minima, iure maiores dolorum sed.",
    },

    {
        img: ProfilePic4,
        review: 
        "Lorem ipsum dolor, sit amet consectetur adipiscing elit. Exofficiis molestiae quod tempora laudantium, cumque error a nisiplaceat quae exercitationem, maiores reicients! Exaque dicta minima, iure maiores dolorum sed.",
    },

   ]
   
    
    return (
        <div className="t-wrapper" id="Testimonial">
            <div className="t-heading">

            <span style={{color: darkMode? 'white': ''}}>Client always get</span> -
            <span>Exceptional Work</span>
            <span style={{color: darkMode? 'white': ''}}> from me...</span>

            <div className="blur s-blur1" style={{background:"#ABF1FF94"}}></div>
            <div className="blur t-blur2" style={{background: "rgb(236 210 255)"}}> </div> 
            </div>

   
            {/* Slider */}
      
              <Swiper
              modules={[Pagination]}
               slidesPerView={1}
              pagination={{ clickable: true }}
              >
                   {clients.map((client, index) =>{
                    return(
                        <SwiperSlide key={index}>
                            <div className="Testimonial">
                            <img src={client.img} alt=""/>
                            <span>{client.review}</span>
                                
                            </div>
                        </SwiperSlide>
                    );
                   })}

              </Swiper>
                          
        </div>
    );
};

export default Testimonial;










